import RESTClient from 'web-app/api/clients/rest-client-famly-app';

export const confirmEmail = (token: string) =>
    RESTClient.postAuthenticatedObservable('v2/email/confirm', {
        token,
    });
